import { render, staticRenderFns } from "./set-meal-item.vue?vue&type=template&id=5a0fec77&scoped=true&"
import script from "./set-meal-item.vue?vue&type=script&lang=js&"
export * from "./set-meal-item.vue?vue&type=script&lang=js&"
import style0 from "./set-meal-item.vue?vue&type=style&index=0&id=5a0fec77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fec77",
  null
  
)

export default component.exports